// extracted by mini-css-extract-plugin
module.exports = {"fix":"Fix_fix__3_uQQ"};